import "../forms.css";

const CheckInput = ({ name, value, setValue }) => {
  return (
    <div className={"formInputCheckbox"}>
      <input
        type="checkbox"
        id={name}
        className={"formInput"}
        name={name}
        value={value}
        onChange={setValue}
        checked={name === value}
      />
      <label htmlFor={name} className={"formLabel"}>
        {name}
      </label>
    </div>
  );
};

export default CheckInput;
